import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { getyears } from "../../Components/Tools";
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import Access from "../../Components/Access";
import Navbar from "../../Components/Navbar";
import UploadLogoOrganisme from '../../Components/UploadLogoOrganisme';
import axios from 'axios';
import qs from 'qs';
import 'react-notifications/lib/notifications.css';
import {NotificationManager} from 'react-notifications';

const Logo = (props) =>
{
    const green = '#59B44A';
    const purple = '#6571FE';
    
    useEffect(() => {
        if (!props.user) {
            props.getUser()
        }
    }, [props.user]);

	return (
        <div>
            <Access needConnection={true} type_user={[0,1,2]}>
                <Navbar user={props.user} />

                <div style={{display: 'flex', margin: 25}}>
                    <p>Paramètre \</p>
                    <p style={{color: purple, marginLeft: 5, fontWeight: 'bold'}}>Logo</p>
                </div>

                {props.user &&
                <div style={{display: 'flex', margin: 10}}>
                    <div style={{flex: 1, margin: 10}}>
                        <UploadLogoOrganisme  user={props.user}/>
                    </div>
                </div>
                }
            </Access>
        </div>
    );
}

export default Logo;
